import { CurrencyPipe, Location } from "@angular/common";
import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { Order } from "src/app/core/entities/order";
import { OrderItem } from "src/app/core/entities/orderItem";
import {
  ObserverPedidoRemovido,
  PedidoService,
} from "src/app/core/services/pedido-service";
import {
  CatalogUiSnapshot,
  ProductService,
} from "src/app/core/services/product-service";
import { SecurityService } from "src/app/core/services/security-service";
import Swal from "sweetalert2";
import { CatalogItemComponent } from "../../components/catalog-item/catalog-item.component";
import { ProductsMenu } from "src/app/core/entities/productMenu";
import { CatalogService } from "src/app/core/services/catalog.service";
import { InitProvider } from "src/app/core/services/init-provider";
import { CorteService } from "src/app/modules/product/services/corte.service";
declare var $: any;
import jspdf from "jspdf";

// Importa a biblioteca que vai te permitir capturar a tela web da sua app web
import html2canvas from "html2canvas";
import { debounceTime, distinctUntilChanged, filter, finalize, first, skip, Subject, takeUntil, tap } from "rxjs";
@Component({
  selector: "app-page-catalog",
  templateUrl: "./page-catalog.component.html",
  styleUrls: ["./page-catalog.component.css"],
})
export class PageCatalogComponent
  implements OnInit, OnDestroy, ObserverPedidoRemovido {
  @ViewChildren(CatalogItemComponent)
  productList!: QueryList<CatalogItemComponent>;

  @ViewChild('filterRef', { static: false })
  filterRef!: ElementRef;
  SITE: ConfiguracoesSite;

  filterVisible = false;
  mobile = false;
  private destroy$ = new Subject<void>();
  public page: number = 0;
  public filters: [];
  public totalPages: number;
  public totalElements: number;
  public pageSize: number = 32;
  public products = [];
  public clientes: any[] = [];
  public filtros;
  public toScroll: boolean = true;
  public rows: any[] = [];
  public paramsObject = {};
  public objectKeys = Object.keys;
  public API_IMAGENS_PRODUTOS: String;
  public menuDinamico: boolean;
  public pedido: Order;
  public tabelaPadrao;
  public isSliderSuperior
  public shareLink;

  //visualizacaoModo 4x4
  public produtoColXL = 3;
  public produtoDescrLen = 44;
  public produtoDescrHeight = 40;
  public produtoDescrFontSize = 0.9;
  public produtoIndispFontSize = 0.8;
  loadPdf = false;
  public produtoHeight = 200;
  public exibe4x4 = false;
  public exibe1x1 = false;
  public exibe6x6 = false;
  public exibeGrade = false;
  public exibeGradeCliente = false;
  public showProduct = false;
  public selectedProduct = null;
  public selectedProductLink = "";
  private lastCatalogLoadedPage: number = null;
  private lastSelectedProductCatalog: number = null;
  isTopScroll: boolean = true;
  public mobileLg: boolean;
  public breadCrumb: any = [];
  public lastElement: string = "";
  public menu: ProductsMenu[];
  public pedidoId = null;
  itensCatalogo = [];
  public form: FormGroup = new FormGroup({});
  public formOld = {};
  public mostraPreco = false;
  data: string[] = [];
  public dropdown: boolean;
  private currencyPipe: CurrencyPipe = new CurrencyPipe("pt-BR");
  public mostraCarrinhoCatalogo: boolean = false;
  public rootUrl: string;
  @Output()
  public redirectToEmiter = new EventEmitter<number>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public productService: ProductService,
    public pedidoService: PedidoService,
    public securityService: SecurityService,
    public toastService: ToastrService,
    private catalogService: CatalogService,
    public initProvider: InitProvider,
    private location: Location,
    private corteService: CorteService
  ) {
    this.rootUrl = this.location.prepareExternalUrl("");
    this.dropdown = false;
    this.isSliderSuperior = Configuracoes.SITE.isSliderSuperior
    this.SITE = Configuracoes.SITE;
    this.itensCatalogo = JSON.parse(this.SITE.catalogo);
    this.mostraCarrinhoCatalogo = Configuracoes.mostraCarrinhoCatalogo;
    this.pedido = this.pedidoService.pedido;
    this.tabelaPadrao = this.SITE.tabelaPadrao;
    //this.API_IMAGENS = Configuracoes.API_IMAGENS;
    this.API_IMAGENS_PRODUTOS = Configuracoes.API_IMAGENS_PRODUTOS;
    this.menuDinamico = Configuracoes.MISC.menuDinamico;

    this.toggleDevice();

    Configuracoes.exibeVisualizacaoCatalogo.forEach((i) => {
      if (i == 1) this.exibe4x4 = true;
      if (i == 2) this.exibe6x6 = true;
      if (i == 3) this.exibeGrade = true;
      if (i == 4) this.exibeGradeCliente = true;
      if (i == 5) this.exibe1x1 = true;
    });

    if (!this.securityService.hasToken() && !this.SITE.mostraPrecoLoginAtivo)
      this.mostraPreco = true;
    if (
      this.securityService.hasToken() &&
      (!this.SITE.mostraPrecoPedidoSelecionado || this.pedido)
    )
      this.mostraPreco = true;

    let modoVisu = "";

    if (window.localStorage.getItem("visualizacaoModo")) {
      modoVisu = window.localStorage.getItem("visualizacaoModo");
    } else {
      modoVisu = Configuracoes.modoVisualizacaoCatalogo;
    }

    if (
      (modoVisu == "grade" || modoVisu == "gradeClientes") &&
      this.pedido &&
      this.pedido.tipo.precoDivergente
    ) {
      this.productService.visualizacaoModo = "4x4";
      window.localStorage.setItem("visualizacaoModo", "4x4");
      modoVisu = "4x4";
      Swal.fire(
        $localize`Modo visualização`,
        $localize`Visualização SKU não suporta preço divergente`,
        "info"
      );
    }

    // if (modoVisu) {
    switch (modoVisu) {
      case "6x6": {
        this.produtoColXL = 2;
        this.produtoDescrLen = 26;
        this.produtoDescrHeight = 40;
        this.produtoDescrFontSize = 0.8;
        this.produtoIndispFontSize = 0.7;
        this.produtoHeight = 160;
        this.productService.visualizacaoModo = "6x6";
        break;
      }
      case "8x8": {
        this.produtoColXL = 118;
        this.produtoDescrLen = 20;
        this.produtoDescrHeight = 32;
        this.produtoDescrFontSize = 0.7;
        this.produtoIndispFontSize = 0.55;
        this.produtoHeight = 110;
        this.productService.visualizacaoModo = "8x8";
        break;
      }
      case "grade": {
        this.productService.visualizacaoModo = "grade";

        if (this.pedido && this.pedido.clientes.length > 1) {
          this.productService.visualizacaoModo = "4x4";
          window.localStorage.setItem("visualizacaoModo", "4x4");
          Swal.fire(
            $localize`Modo visualização`,
            $localize`Visualização SKU não suportada para mais de 01 cliente`,
            "info"
          );
        }
        break;
      }
      case "grade2": {
        this.productService.visualizacaoModo = "grade2";
        break;
      }
      case "gradeClientes": {
        this.productService.visualizacaoModo = "gradeClientes";
        this.productService.selectedOrder = 2;
        break;
      }

      default: {
        this.productService.visualizacaoModo = "4x4";
        window.localStorage.setItem("visualizacaoModo", "4x4");
      }
    }
    this.productService.refresh = this.ngOnInit.bind(this);
  }

  // @HostListener("window:resize", ["$event"])
  @HostListener('window:resize')
  toggleDevice() {
    if (window.innerWidth < 768) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
    if (window.innerWidth < 1400) {
      this.mobileLg = true;
    } else {
      this.mobileLg = false;
    }
  }

  toggleFilter() {
    this.filterVisible = !this.filterVisible;

    // Scroll to top only in mobile when opening filter
    if (this.mobile && this.filterVisible) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
  async geraPdfCatalogo() {
    this.loadPdf = true;
    this.productService.catalogoPDF(
      0,
      this.pageSize,
      async function (resp) {
        if (resp.produtos > 1) {
          this.toastService.error("Filtragem sem produtos disponiveis")
          return
        }
        // const products = resp.produtos.content.map(p => ({preco: p.preco, imagem: p.imagem, descricao: p.descricao, referencia: p.referencia}))
        try {
          const catalogo: any = await new Promise((resolve, reject) => {
            this.catalogService.getCatalogoPdf({
              dados: {
                produtos: resp.produtos.content,
              //  url_imagens: "https://www.madson.com.br/images/",
              //  url_imagens_produtos: "https://www.madson.com.br/images/produtos/",
                url_imagens: Configuracoes.API_IMAGENS,
                url_imagens_produtos: Configuracoes.API_IMAGENS_PRODUTOS,
              
              },
              layout: 'catalogo'
            }, (res) => {
              if (res) {
                resolve(res);
              } else {
                console.error("Erro ao carregar pedido");
                reject("Erro ao carregar pedido");
              }
            },
              (res) => {
                this.toastService.warning(res.statusText);
                this.loadPdf = false;
              }
            )
          });
          if (catalogo.arquivo) {
            window.open(catalogo.arquivo, '_blank');
          }
          // await gerarPDFPedidos(pedido, this.layout);
          this.loadPdf = false;
        } catch (erro) {
          console.error("Erro geral no processo:", erro);
        } finally {
          this.loadPdf = false;
        }
      }.bind(this),
      null
    );

  }

  increment(field: string, multiplo: number, qtdMaxDisponivel: number) {
    const control = this.form.get(field);
    const step = this.getStep(multiplo);
    const max = this.getMax(qtdMaxDisponivel);
    const current = Number(control?.value) || 0;

    const newValue = Math.min(current + step, max);
    control?.setValue(newValue);
    const fakeEvent = {
      target: { name: field, value: newValue }
    } as unknown as Event;

    this.addItemCart(fakeEvent)

    setTimeout(() => {
      const input = document.getElementById('searchModalField') as HTMLInputElement;
      input?.focus();
    });
  }

  decrement(field: string, multiplo: number, qtdMaxDisponivel: number) {
    const control = this.form.get(field);
    const step = this.getStep(multiplo);
    const current = Number(control?.value) || 0;

    const newValue = Math.max(current - step, 0);
    control?.setValue(newValue);

    const fakeEvent = {
      target: { name: field, value: newValue }
    } as unknown as Event;

    this.addItemCart(fakeEvent)
    setTimeout(() => {
      const input = document.getElementById('searchModalField') as HTMLInputElement;
      input?.focus();
    });
  }

  getStep(multiplo: number): number {
    return multiplo || 1;
  }

  getMax(quantidademaximadisponivelgrade: number): number {
    return quantidademaximadisponivelgrade || Infinity;
  }

  print() {
    this.loadPdf = true;

    setTimeout(() => {
      try {
        const data = document.getElementById("print");

        if (!data) {
          console.error("Elemento #print não encontrado.");
          this.loadPdf = false;
          return;
        }

        // Clona o conteúdo do elemento #print
        const clone = data.cloneNode(true) as HTMLElement;

        // Remove os elementos com a classe .bottom
        const elementsToRemove = clone.querySelectorAll(".bottom");
        elementsToRemove.forEach(el => el.remove());

        // Cria um container oculto para renderização
        const tempContainer = document.createElement("div");
        tempContainer.classList.add("col-md-10");
        tempContainer.style.position = "absolute";
        tempContainer.style.position = "absolute";
        tempContainer.style.left = "-9999px";
        tempContainer.style.top = "0";
        tempContainer.style.zIndex = "-1000";
        tempContainer.appendChild(clone);
        document.body.appendChild(tempContainer); // <-- ISSO resolve o erro

        const htmlWidth = clone.offsetWidth || 800;
        const htmlHeight = clone.offsetHeight || 1120;
        const topLeftMargin = 15;
        const pdf = new jspdf("p", "pt", [htmlWidth + 15, htmlHeight]);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const canvasImageWidth = pdfWidth - topLeftMargin * 2;
        const canvasImageHeight = (canvasImageWidth * htmlHeight) / htmlWidth;

        html2canvas(clone, { scale: 1, useCORS: true, allowTaint: true })
          .then((canvas) => {
            const imgData = canvas.toDataURL("image/jpeg", 1.0);
            let position = 0;
            let heightLeft = canvasImageHeight;

            pdf.addImage(imgData, "JPEG", topLeftMargin, position, canvasImageWidth, canvasImageHeight);
            heightLeft -= pdfHeight;

            while (heightLeft > 0) {
              position = heightLeft - canvasImageHeight;
              pdf.addPage();
              pdf.addImage(imgData, "JPEG", topLeftMargin, position, canvasImageWidth, canvasImageHeight);
              heightLeft -= pdfHeight;
            }

            pdf.save("catalogo.pdf");
          })
          .catch((canvasError) => {
            console.error("Erro ao capturar imagem com html2canvas:", canvasError);
            this.toastService.error(canvasError, "Erro ao capturar imagem com html2canvas:")
            this.loadPdf = false;
          })
          .finally(() => {
            document.body.removeChild(tempContainer); // limpa o DOM
            this.loadPdf = false;
          });

      } catch (err) {
        console.error("Erro inesperado ao gerar o PDF:", err);
        this.toastService.error(err, "Erro inesperado ao gerar o PDF:")
        this.loadPdf = false;
      }
    }, 100);
  }



  checkDevice() {
    this.mobile = window.innerWidth < 768;
  }
  ngOnDestroy(): void {
    this.productService.setCatalogUiStasher(null);
    this.pedidoService.removeObserverToRemovedOrders(this);
    window.removeEventListener('resize', this.checkDevice.bind(this));
  }

  /** Snapshot da grade para restaurar após voltar da página de corte. */
  buildCatalogUiSnapshot(): CatalogUiSnapshot {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    return {
      products: this.products,
      page: this.page,
      totalPages: this.totalPages,
      totalElements: this.totalElements,
      toScroll: this.toScroll,
      lastCatalogLoadedPage: this.lastCatalogLoadedPage,
      scrollTop: Number.isFinite(scrollTop) ? scrollTop : 0,
      returnUrl: this.router.url,
      filterVisible: this.filterVisible,
      filtros: this.filtros,
    };
  }

  /** Restaura scroll após reidratar a grade (DOM precisa estar pintado). */
  private restaurarScrollCatalogo(scrollTop: number, toScrollDepois: boolean): void {
    const y = Math.round(Number(scrollTop) || 0);
    if (y <= 0) {
      this.toScroll = toScrollDepois;
      return;
    }
    const aplicar = () => {
      window.scrollTo({ top: y, left: 0, behavior: "auto" });
      if (typeof $ !== "undefined") {
        $(window).scrollTop(y);
      }
    };
    this.toScroll = false;
    setTimeout(aplicar, 0);
    setTimeout(aplicar, 80);
    setTimeout(() => {
      aplicar();
      this.toScroll = toScrollDepois;
    }, 200);
  }

  notify(pedido: Order) {
    this.selectByPage(0, true);
  }
  updateRemove(pedido: Order) {
    this.selectByPage(0, false, true);
  }
  updateQuantity(productId: number) {
    let quantity = this.productService.getQuantityByProductId(productId);

    let found = this.productList
      .toArray()
      .find((comp) => comp.product.id === productId);

    if (found) {
      found.updateQuantity(quantity);
    } else {
      console.warn("Produto não encontrado:", productId);
    }
  }

  onSomenteComFotos() {
    if (this.productService.mostraComFotoModo) {
      window.localStorage.setItem("mostraComFotoModo", "false");
    } else {
      window.localStorage.setItem("mostraComFotoModo", "true");
    }
  }

  onSomenteDisponiveis() {
    if (this.productService.somenteDisponiveis) {
      window.localStorage.setItem("somenteDisponiveis", "false");
    } else {
      window.localStorage.setItem("somenteDisponiveis", "true");
    }
  }

  onMostra4em4() {
    let atualiza = false;
    if (
      ["grade", "gradeClientes"].includes(this.productService.visualizacaoModo)
    ) {
      atualiza = true;
    }
    this.produtoColXL = 3;
    this.produtoDescrLen = 44;
    this.produtoDescrHeight = 40;
    this.produtoDescrFontSize = 0.9;
    this.produtoIndispFontSize = 0.7;
    this.produtoHeight = 200;
    this.productService.visualizacaoModo = "4x4";
    window.localStorage.setItem("visualizacaoModo", "4x4");
    if (atualiza) {
      this.selectByPage(0, true);
    }
  }

  breadCrumbSave(bc) {
    if (bc !== "") {
      let arr: any = [];
      bc.toLowerCase().split(">").length
        ? (arr = bc.toLowerCase().split(">"))
        : (arr = "");
      this.lastElement = arr.pop();
      for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i];
      }
      this.breadCrumb = arr;
    }
  }

  onMostra6em6() {
    let atualiza = false;
    if (
      ["grade", "gradeClientes"].includes(this.productService.visualizacaoModo)
    ) {
      atualiza = true;
    }
    this.produtoColXL = 2;
    this.produtoDescrLen = 26;
    this.produtoDescrHeight = 40;
    this.produtoDescrFontSize = 0.8;
    this.produtoIndispFontSize = 0.7;
    this.produtoHeight = 160;
    this.productService.visualizacaoModo = "6x6";
    window.localStorage.setItem("visualizacaoModo", "6x6");
    if (atualiza) {
      this.selectByPage(0, true);
    }
  }

  onMostra8em8() {
    let atualiza = false;
    if (this.productService.visualizacaoModo == "grade") {
      atualiza = true;
    }
    this.produtoColXL = 118;
    this.produtoDescrLen = 20;
    this.produtoDescrHeight = 32;
    this.produtoDescrFontSize = 0.7;
    this.produtoIndispFontSize = 0.55;
    this.produtoHeight = 110;
    this.productService.visualizacaoModo = "8x8";
    window.localStorage.setItem("visualizacaoModo", "8x8");
    if (atualiza) {
      this.selectByPage(0, true);
    }
  }

  onMostraGrade() {
    if (this.pedido && this.pedido.clientes.length > 1) {
      Swal.fire(
        $localize`Modo visualização`,
        $localize`Visualização SKU não suportada para mais de 01 cliente`,
        "info"
      );
    } else if (this.pedido && this.pedido.tipo.precoDivergente) {
      Swal.fire(
        $localize`Modo visualização`,
        $localize`Visualização SKU não suporta preço divergente`,
        "info"
      );
    } else {
      this.productService.visualizacaoModo = "grade";
      window.localStorage.setItem("visualizacaoModo", "grade");
      this.selectByPage(0, true);
    }
  }
  public addCart(_quantity: number): void {}

  onMostraGrade2() {
    let atualiza = false;
    if (this.productService.visualizacaoModo == "grade") {
      atualiza = true;
    }
    this.produtoColXL = 118;
    this.produtoDescrLen = 20;
    this.produtoDescrHeight = 32;
    this.produtoDescrFontSize = 0.7;
    this.produtoIndispFontSize = 0.55;
    this.produtoHeight = 110;
    this.productService.visualizacaoModo = "grade2";
    window.localStorage.setItem("visualizacaoModo", "grade2");
    if (atualiza) {
      this.selectByPage(0, true);
    }
  }

  onMostraGradeClientes() {
    if (this.pedido && this.pedido.tipo.precoDivergente) {
      Swal.fire(
        $localize`Modo visualização`,
        $localize`Visualização SKU não suporta preço divergente`,
        "info"
      );
    } else {
      this.productService.visualizacaoModo = "gradeClientes";
      this.productService.selectedOrder = 2;
      window.localStorage.setItem("visualizacaoModo", "gradeClientes");

      this.selectByPage(0, true);
    }
  }

  ngOnInit() {
    this.productService.setCatalogUiStasher(() => this.buildCatalogUiSnapshot());
    const restored = this.productService.consumeStashedCatalogUi();

    if (!restored) {
      this.productService.filtroDescr = [];
    }
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice.bind(this));
    this.breadCrumb = "";
    this.route.queryParamMap.subscribe((params: any) => {
      if (params.keys.length > 0) {
        this.paramsObject = params.params.departament;
        this.breadCrumb =
          params.params.breadCrumb === ""
            ? []
            : params.params.breadCrumb.split("+");
        this.lastElement = params.params.lastElement.replaceAll("_", " ");
      }
    });
    if (
      this.paramsObject !== undefined &&
      Object.keys(this.paramsObject).length > 0
    ) {
      this.productService.filtro["menuIds"] = [this.paramsObject];
    } else if (this.productService.filtro["menuIds"] === undefined) {
      this.productService.filtro = {
        busca: this.productService.filtro["busca"],
      };
    }
    this.catalogService.getMenu().subscribe((menu) => (this.menu = menu));
    if (!restored) {
      localStorage.removeItem("lastWord");
    }
    this.pedidoService.registerObserverToRemovedOrders(this);

    if (restored) {
      this.products = restored.products;
      this.page = restored.page;
      this.totalPages = restored.totalPages;
      this.totalElements = restored.totalElements;
      this.toScroll = restored.toScroll;
      this.lastCatalogLoadedPage = restored.lastCatalogLoadedPage;
      this.filterVisible = restored.filterVisible ?? false;
      this.filtros = restored.filtros ?? this.filtros;
      this.pedido = this.pedidoService.pedido;
      this.restaurarScrollCatalogo(
        restored.scrollTop ?? 0,
        restored.toScroll ?? false
      );
      if (this.initProvider.inicializaPedido) {
        this.pedidoService.pedido$
          .pipe(
            takeUntil(this.destroy$),
            filter((p) => p !== null),
            distinctUntilChanged((a, b) => a.id === b.id),
            debounceTime(100),
            skip(1)
          )
          .subscribe((pedido) => {
            this.pedido = pedido;
            this.selectByPage(0, true);
          });
      }
      return;
    }

    if (!this.initProvider.inicializaPedido) {
      this.pedido = this.pedidoService.pedido
      this.selectByPage(0, true);
    } else {
      this.selectByPage(0, true);

      this.pedidoService.pedido$
        .pipe(
          takeUntil(this.destroy$),
          filter(p => p !== null),
          distinctUntilChanged((a, b) => a.id === b.id),
          debounceTime(100)
        )
        .subscribe(pedido => {
          this.pedido = pedido;
          this.selectByPage(0, true);
        });


    }
  }

  share() {
    if (this.productService.loading) return;

    this.productService.selectTabelaFilial();
    let tabela = null;
    let filial = null;
    if (this.productService.tabelaSelecionada) {
      tabela = this.productService.tabelaSelecionada;
    }
    if (this.productService.filialSelecionada) {
      filial = this.productService.filialSelecionada;
    }

    let share = {
      tabela: tabela,
      filial: filial,
      filtro: [this.productService.menusIds],
      mostraPreco: this.SITE.mostraPrecoLinkShare,
      mostraComFotoModo: false,
      somenteDisponiveis: false,
    };
    this.productService.share(
      share,
      function (resp) {
        this.shareLink =
          document.location.origin + "/s/" + resp.id + "/catalogo";
        $("#shareCatalogoLink").modal("show");
      }.bind(this)
    );
  }

  copyText() {
    let el = document.getElementById("shareCatalogoLinkInput") as any;
    el.select();
    el.setSelectionRange(0, 99999);
    document.execCommand("copy");
  }

  removeBusca() {
    this.productService.filtro = {};
    this.productService.filtroDescr = [];
    this.toScroll = false;
    this.products = [];
  }

  limpaBusca(busca) {
    this.productService.filtro["busca"] = this.productService.filtro[
      "busca"
    ].filter((b) => b != busca);
    if (this.productService.filtro["busca"].length == 0) {
      delete this.productService.filtro["busca"];
    }
    this.toScroll = false;
    this.products = [];
    this.selectByPage(0, true);
  }
  removeItem(item) {
    let arr = JSON.parse(localStorage.getItem("selectedItem"));
    let updatedItems = [];
    for (const category of arr) {
      if (category.parent === item[0].parent) {
        for (let i = 0; i < category.items.length; i++) {
          if (category.items[i].id !== item[1]) {
            updatedItems.push(category.items[i]);
          }
        }
        category.items = updatedItems;
        break;
      }
    }
    localStorage.setItem("selectedItem", JSON.stringify(arr));
  }

  limpaBuscaDescr(id, filtro) {
    this.productService.loadingCatalogo = true;
    this.productService.filtroDescr = this.productService.filtroDescr.filter(
      (f) => f.id + f.filtro != id + filtro
    );
    this.productService.filtro[filtro] = this.productService.filtro[
      filtro
    ].filter((f) => f != id);
    if (this.productService.filtro[filtro].length == 0) {
      delete this.productService.filtro[filtro];
    }
    this.toScroll = false;
    this.products = [];
    this.selectByPage(0, true);
  }
  public limpaTudo() {
    localStorage.removeItem("selectedItem");
    localStorage.removeItem("breadCrumb");
    for (let i = 0; i < document.getElementsByTagName("input").length; i++) {
      if (document.getElementsByTagName("input")[i].type === "checkbox") {
        document.getElementsByTagName("input")[i].checked = false;
      }
    }
    this.productService.filtro["menuIds"] = [];
    this.toScroll = false;
    this.products = [];
    this.selectByPage(0, true);
  }

  public limpaBuscaFiltros() {

    this.productService.filtro = {};
    this.productService.filtroDescr = [];
    this.toScroll = false;
    this.products = [];
    this.selectByPage(0, true);
    this.breadCrumb = "";
    this.productService.menusIds = 0;
    this.router.navigate(["/catalogo"]);
  }

  findIdByDescription(data, description) {
    for (const item of data) {
      if (
        item.description.replaceAll(" ", "") === description.replaceAll("_", "")
      ) {
        return item.id;
      }
      if (item.children.length > 0) {
        const id = this.findIdByDescription(item.children, description);
        if (id) {
          return id;
        }
      }
    }
    return null; // Retorna null se a descrição não for encontrada
  }
  showMenu(b, breadCrumb) {
    let id = 0;
    let lastElement = b;
    let newArr: any = [];
    let bcFlag = true;

    for (let i = 0; i < breadCrumb.length; i++) {
      if (bcFlag) {
        newArr.push(breadCrumb[i]);
        if (breadCrumb[i] === lastElement) {
          bcFlag = false;
        }
      }
    }
    this.productService.menusIds = this.findIdByDescription(
      this.menu,
      b.replace(" ", "").split(" ").join("_").toUpperCase()
    );
    this.router.navigate(["/catalogo"], {
      replaceUrl: true,
      queryParams: {
        departament: this.findIdByDescription(
          this.menu,
          b.replace(" ", "").split(" ").join("_").toUpperCase()
        ),
        lastElement: newArr.pop(),
        breadCrumb: newArr
          .toString()
          .replaceAll(",", "")
          .replaceAll("  ", "+")
          .replaceAll(" ", "_"),
      },
    });

    if (this.router.url.split("?")[0] === "/catalogo") {
      this.productService.refresh();
    }
  }

  mainCatalog() {
    this.breadCrumb = [];
    this.productService.filtro["menuIds"] = [];
    this.productService.menusIds = 0;
    this.lastElement = "";
    this.router.navigate(["/catalogo"]);
    this.selectByPage(0, true);
  }

  filtrarPorMenuDinamico(ids) {

    this.router.navigate(["/catalogo"], {
      replaceUrl: true,
      queryParams: {
        departament: ids[0],
        breadCrumb: this.breadCrumb
          .toString()
          .replaceAll(",", "")
          .replaceAll("  ", "+")
          .replaceAll(" ", "_"),
        lastElement: this.lastElement.replace(" ", "").split(" ").join("_"),
      },
    });

    if (this.router.url.split("?")[0] === "/catalogo") {
      this.productService.refresh();
    }

  }

  filtrar(data: any) {
    this.productService.loadingCatalogo = true;
    const filtro = data["filtro"];
    const nome = data["nome"];
    const filtroDescr = data["filtroDescr"];
    const id = data["id"];
    const event = data["event"];

    if (this.productService.loading) return;

    let isChecked = event.target.checked;
    if (this.productService.filtro[filtro]) {
      const index = this.productService.filtro[filtro].indexOf(id);
      if (index == -1) {
        this.productService.filtro[filtro].push(id);
      } else {
        this.productService.filtro[filtro].splice(index, 1);
      }
      if (this.productService.filtro[filtro].length == 0) {
        delete this.productService.filtro[filtro];
      }
    } else {
      this.productService.filtro[filtro] = [id];
    }

    this.productService.filtroDescr = this.productService.filtroDescr.filter(
      (f) => f.id + f.filtro != id + filtro
    );
    if (isChecked) {
      this.productService.filtroDescr.push({
        id: id,
        filtro: filtro,
        label: filtroDescr,
        nome: nome,
      });
    }
    this.selectByPage(0, true);
    $(window).scrollTop(0);
  }
  onItemFromCart(item: OrderItem) {
    this.products = this.products.map(p => {
      if (p.id === item.id) {
        return {
          ...p,
          quantidade: 0
        };
      }
      return p;
    });
    // this.selectByPage(this.page)
  }

  selectByPage(page, force = false, updateQtd = false) {
    if (!force && page >= this.totalPages) {
      this.toScroll = false;
      return;
    }
    this.page = page;
    if (updateQtd) {
      return
    }
    if (page == 0) {
      this.products = [];
    }
    if (this.pedido) {

      this.productService.catalogo(
        page,
        this.pageSize,
        this.callbackProducts.bind(this),
        this.pedido.id
      );
    } else {

      this.productService.catalogo(
        page,
        this.pageSize,
        this.callbackProducts.bind(this),
        null
      );
    }

  }

  calculaImposto(imposto, _precopromocional, _preco) {
    if (imposto)
      return (
        "+ R$ " +
        this.currencyPipe.transform(
          this.calculaValorImposto(imposto, _precopromocional, _preco),
          "",
          ""
        )
      );
  }

  calculaValorImposto(imposto, _precopromocional, _preco) {
    if (imposto) {
      let preco: number = 0;
      if (_precopromocional > 0) {
        preco = _precopromocional;
      } else {
        preco = _preco;
      }
      let valorImposto: number = this.productService.calculaValorImposto(
        preco,
        imposto.ipi,
        imposto.alicms,
        imposto.substicms,
        imposto.alicmsorigem,
        imposto.fcpSt
      );
      return valorImposto;
    }
    return 0;
  }
  addItemCartEnter(e) {
    this.addItemCart(e)
    setTimeout(() => {
      const inputs = Array.from(document.querySelectorAll('input[name]')) as HTMLInputElement[];
      const currentIndex = inputs.findIndex(input => input.name === e.target.name);
      if (currentIndex >= 0 && currentIndex < inputs.length - 1) {
        const nextInput = inputs[currentIndex + 1];
        nextInput.focus();
        nextInput.select(); // opcional: seleciona o conteúdo do input
      }
    }, 0);
  }
  addItemCart(e) {
    let id = e.target.name;
    let _id = id.split("@");
    let pro: number = parseInt(_id[0]);
    let cor: number = parseInt(_id[1]);
    let est: number = parseInt(_id[2]);
    let tam: string = _id[3];
    let cli: number = parseInt(_id[4]);
    let value = this.form.value[e.target.name];
    let qtd: number = value !== null && value != "" ? parseInt(value) : 0;
    let preco: number = 0;
    let imposto;
    let proRef = null;
    let proDescr = null;
    let proNome: string = null;
    let proImagem: string = null;
    $('input[name="' + id + '"]').blur();

    if (
      ((!qtd || qtd < 1) && this.formOld[id] == 0) ||
      this.formOld[id] == qtd
    ) {
      return;
    }
    for (let i = 0; i < this.products.length; i++) {
      let p = this.products[i];

      if (
        p["id"] == pro &&
        p["corid"] == cor &&
        p["estampaid"] == est &&
        p["tamanho"] == tam
      ) {
        if (!this.form.valid) {
          if (p.estoque < p.quantidademaximadisponivelgrade) {
            this.toastService.warning($localize`Estoque insuficiente!`, $localize`Produto`, {
              positionClass: "toast-bottom-left",
            });
          } else {
            this.toastService.warning(
              $localize`Máximo disponível ` + p["quantidademaximadisponivelgrade"],
              $localize`Produto`,
              { positionClass: "toast-bottom-left" }
            );
          }
          $('input[name="' + id + '"]').focus();
          return;
        }

        if (qtd % p["multiplo"] !== 0) {
          this.toastService.warning(
            $localize`Quantidade deve ser múltiplo de ` + p["multiplo"],
            $localize`Produto`,
            { positionClass: "toast-bottom-left" }
          );
          $('input[name="' + id + '"]').focus();
          return;
        }

        imposto = p["imposto"];
        proRef = p["referencia"];
        proDescr = p["descricao"];
        proNome = p["nome"] ?? p["imagem"];
        proImagem = p["imagem"] ?? p["nome"];
        if (p["precopromocional"] > 0) {
          preco = p["precopromocional"];
        } else {
          preco = p["preco"];
        }

        break;
      }
    }

    if (preco <= 0) {
      Swal.fire($localize`Produto`, $localize`Preço incorreto`, "warning");
      return;
    }

    let valorImposto: number = 0;
    let impostoCalc = {
      al_fcp_st: null,
      valor_fcp_st: null,
      base_ipi: null,
      al_ipi: null,
      base_sub: null,
      al_sub: null,
      valor_ipi: null,
      valor_sub: null,
      base_fcp_st: null,
    };
    if (imposto) {
      impostoCalc = this.productService.calculaImposto(
        preco,
        imposto.ipi,
        imposto.alicms,
        imposto.substicms,
        imposto.alicmsorigem,
        imposto.fcpSt
      );
      valorImposto = this.productService.calculaValorImposto(
        preco,
        imposto.ipi,
        imposto.alicms,
        imposto.substicms,
        imposto.alicmsorigem,
        imposto.fcpSt
      );
    }
    let ___total = preco + valorImposto;
    let newItem: OrderItem = {
      cor: cor,
      corDescricao: "",
      estampa: est,
      tamanho: tam,
      cliente: cli,
      produto: pro,
      produtoReferencia: proRef,
      produtoDescricao: proDescr,
      nome: proNome,
      imagem: proImagem,
      quantidade: qtd,
      preco: preco,
      acrescimo: 0,
      acrescimoPercent: 0,
      desconto: 0,
      descontoPercent: 0,
      total: qtd * ___total,
      imp_estado: imposto ? imposto.estado : null,
      imp_ipi: imposto ? imposto.ipi : null,
      imp_alicms: imposto ? imposto.alicms : null,
      imp_alicmsorigem: imposto ? imposto.alicmsorigem : null,
      imp_alfcpst: imposto ? imposto.fcpSt : null,
      imp_substicms: imposto ? imposto.substicms : null,
      imp_baseipi: impostoCalc.base_ipi,
      imp_basesubst: impostoCalc.base_sub,
      imp_basefcpst: impostoCalc.base_fcp_st,
      imp_valoripi: impostoCalc.valor_ipi,
      imp_valorsubst: impostoCalc.valor_sub,
      imp_valorfcpst: impostoCalc.valor_fcp_st,
      imp_valorimposto: valorImposto > 0 ? valorImposto : null,
      codigoBarras: null,
    };
    this.pedidoService.setCartItemsSku(
      [newItem],
      function (resp) {
        this.formOld[id] = newItem.quantidade;
        this.form.markAsPristine();
        this.pedido = resp;
        this.pedidoService.select(resp);
      }.bind(this),
      function (error) {
        if (error.status === 400) {
          this.toastService.warning(error.error.detail, $localize`Produto`, {
            positionClass: "toast-bottom-right",
          });
          window.location.reload();
        }
        let obj = JSON.parse(error._body);
        if (obj && obj.msg) {
          this.error = true;
          this.errorMsg = obj.msg;
        }
      }.bind(this)
    );


  }

  callbackProducts(resp) {
    this.filtros = resp["filtros"];
    const pages = resp["produtos"];
    this.toScroll = true;
    this.totalPages = pages.totalPages;
    this.totalElements = pages.totalElements;
    // this.products = [];

    if (this.pedido && this.productService.visualizacaoModo === "gradeClientes") {
      this.clientes = this.pedido.clientes.map((pc) => pc.cliente);
    }

    Object.keys(this.form.controls).forEach((key) => {
      this.form.removeControl(key);
    });
    this.formOld = {};

    if (pages.content) {
      if (
        this.pedido &&
        this.productService.visualizacaoModo.startsWith("grade")
      ) {

        for (const product of pages.content) {
          this.products.push(product);

          for (const clienteData of this.pedido.clientes) {
            const cliId = clienteData.cliente.id;
            let value = "";

            if (this.productService.visualizacaoModo === "gradeClientes") {
              const clienteProduto = pages.clientes?.find(
                (c_) => c_.cliente === cliId && c_.produto === product.id
              );
              if (clienteProduto) {
                value = clienteProduto.quantidade;
              }
            } else if (product.quantidade) {
              value = product.quantidade + "";
            }

            const id = `${product.id}@${product.corid}@${product.estampaid}@${product.tamanho}@${cliId}`;

            let validators = [Validators.min(0)];
            if (this.pedido.tipo.estoque) {
              const max = Math.min(
                product.estoque ?? Infinity,
                product.quantidademaximadisponivelgrade ?? Infinity
              );
              validators.push(Validators.max(max));
            }

            const fc = new FormControl(value, validators);
            this.form.addControl(id, fc);
            this.formOld[id] = value || 0;
          }
        }
      } else {
        this.products.push(...pages.content);
      }
    }

    if (this.totalPages === 0 && this.totalElements === 1 && this.products.length === 1) {
      this.router.navigate(["/produto/" + this.products[0].id]);
      this.removeBusca();
    }
  }


  // callbackProducts(resp) {
  //   this.filtros = resp["filtros"];
  //   let pages = resp["produtos"];
  //   this.toScroll = true;
  //   this.totalPages = pages.totalPages;
  //   this.totalElements = pages.totalElements;
  //   if (pages.content) {
  //     if (
  //       this.pedido &&
  //       this.productService.visualizacaoModo.startsWith("grade")
  //     ) {
  //       // let cli = (this.pedido ? this.pedido.clientes[0].cliente.id + '' : '');

  //       for (var i = 0; i < pages.content.length; i++) {
  //         let product = pages.content[i];
  //         this.products.push(product);

  //         for (var c = 0; c < this.pedido.clientes.length; c++) {
  //           let cli = this.pedido.clientes[c].cliente.id;
  //           let value = "";

  //           if (this.productService.visualizacaoModo == "gradeClientes") {
  //             let clienteProduto =
  //               pages.clientes != null &&
  //               pages.clientes.filter(
  //                 (c_) => c_.cliente === cli && c_.produto === product.id
  //               );

  //             if (clienteProduto.length > 0)
  //               value = clienteProduto[0].quantidade;
  //           } else {
  //             if (product.quantidade) {
  //               value = product.quantidade + "";
  //             }
  //           }

  //           let id =
  //             product.id +
  //             "@" +
  //             product.corid +
  //             "@" +
  //             product.estampaid +
  //             "@" +
  //             product.tamanho +
  //             "@" +
  //             cli;

  //           let fc = new FormControl(value, [Validators.min(0)]);
  //           if (this.pedido.tipo.estoque) {
  //             fc = new FormControl(value, [
  //               Validators.min(0),
  //               Validators.max(
  //                 product.estoque < product.quantidademaximadisponivelgrade
  //                   ? product.estoque
  //                   : product.quantidademaximadisponivelgrade
  //               ),
  //             ]);
  //           }
  //           this.form.addControl(id, fc);
  //           this.formOld[id] = product.quantidade ? product.quantidade : 0;
  //         }
  //       }
  //     } else {
  //       for (var i = 0; i < pages.content.length; i++) {
  //         let p = pages.content[i];
  //         this.products.push(p);
  //       }
  //     }
  //   }
  //   if (
  //     this.totalPages == 0 &&
  //     this.totalElements == 1 &&
  //     this.products.length == 1
  //   ) {
  //     this.router.navigate(["/produto/" + this.products[0].id]);
  //     this.removeBusca();
  //   }

  //   if (
  //     this.pedido &&
  //     this.productService.visualizacaoModo == "gradeClientes"
  //   ) {
  //     let clientes: any = [];
  //     this.pedidoService.pedido.clientes.forEach((pc) => {
  //       clientes.push(pc.cliente);
  //     });
  //     this.clientes = clientes;
  //   }
  // }

  callPhotos(idProduto, codCor) {
    this.productService.getPhotos(
      idProduto,
      function (resp) {
        let temVariacao = false;
        let _htmlImagens = "";
        for (let i = 0; i < resp.length; i++) {
          let img = resp[i];
          _htmlImagens +=
            '<a href="' +
            Configuracoes.API_IMAGENS_PRODUTOS +
            img.nome +
            '" data-gallery="gallery-catalogo"></a>';
        }
        $("#htmlLightBox").html(_htmlImagens);
        $("#htmlLightBox a:first").ekkoLightbox();
      }.bind(this)
    );
  }

  onSortChange(event) {
    let value = event.target.value;
    if (!value) return;

    switch (parseInt(value)) {
      case 1:
        this.productService.ordem = "data";
        break;

      case 2:
      case 3:
        this.productService.ordem = "descricao";
        break;

      case 4:
      case 5:
        this.productService.ordem = "preco";
        break;

      default: {
        break;
      }
    }

    switch (parseInt(value)) {
      case 2:
      case 5:
        this.productService.direcao = "ASC";
        break;

      default:
        this.productService.direcao = "DESC";
        break;
    }
    this.selectByPage(0, true);
  }

  // @HostListener("scroll", ["$event"])
  @HostListener('window:resize')
  onTableScroll() {
    let elementTop = $("#fim-produtos").offset().top;
    let elementBottom = elementTop + $("#fim-produtos").outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();
    if (elementBottom > viewportTop && elementTop < viewportBottom) {
      if (this.toScroll) {
        this.toScroll = false;

        this.selectByPage(this.page + 1);
      }
    }
  }

  @HostListener("window:scroll")
  onWindowScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isTopScroll = scrollTop === 0;
    let elementTop = $("#fim-produtos").offset().top;
    let elementBottom = elementTop + $("#fim-produtos").outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();
    if (elementBottom > viewportTop && elementTop < viewportBottom) {
      if (this.toScroll) {
        this.toScroll = false;

        this.selectByPage(this.page + 1);
      }
    }
  }

  redirectTo(id: number) {
    const p = this.products?.find((x: any) => x.id === id);
    if (this.corteService.deveUsarPaginaCorte(p, false)) {
      this.productService.stashCurrentCatalogUiForReturn();
      this.router.navigate(["/produto-corte", id], {
        queryParams: { corte: "1" },
      });
      return;
    }
    const link = `${window.location.origin}/produto/${id}`;
    this.showProduct = false;
    this.selectedProductLink = link;
    if (Configuracoes.exibeModalProdutoCatalogo) {
      setTimeout(() => {
        this.selectedProduct = id;
        this.showProduct = true;
        $("#productDetails").modal("show");
      });
    } else {
      this.router.navigate(["/produto", id]);
    }
  }

  copyLink() {
    const link = `${window.location.origin}/produto/${this.selectedProduct}`;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        this.toastService.success(
          $localize`Link copiado com sucesso para a área de transferência`,
          $localize`Produto`,
          {
            positionClass: "toast-bottom-left",
          }
        );
      })
      .catch((err) => {
        this.toastService.warning(
          $localize`Erro ao copiar link para a área de transferência`,
          $localize`Produto`,
          {
            positionClass: "toast-bottom-left",
          }
        );
      });
  }

  send(data) {
    this.productService.filtro = {
      ...this.productService.filtro,
      preco_min: Math.floor(data.value),
      preco_max: Math.ceil(data.highValue),
    };
    this.selectByPage(0, true);
    $(window).scrollTop(0);
  }
}
